import React from 'react';
import { Container } from '../../components/ui/Container';
export function ArabicRefundPolicy() {
  return <section className="py-16 text-right md:py-24" dir="rtl" data-id="element-3727" data-mp="39c3sl3hfg7d6">
      <Container data-id="element-3728" data-mp="35bkz74zvyt8v">
        <article className="mx-auto max-w-4xl" data-id="element-3729" data-mp="35b1skkforra5">
          <h1 className="font-display text-4xl font-semibold leading-[1.5] text-ink-900 md:text-6xl" data-id="element-3730" data-mp="35bt9qq8jdmgw">
            سياسة الاسترداد
          </h1>
          <p className="mt-4 text-ink-500" data-id="element-3731" data-mp="xv6me9euetz">
            <strong data-id="element-3732" data-mp="wtknequw7xh">آخر تحديث:</strong> 1 فبراير 2026
          </p>

          <div className="mt-10 space-y-8 leading-loose text-ink-700" data-id="element-3733" data-mp="3t0w48yo9r9st">
            <h2 className="mt-12 font-display text-2xl font-semibold leading-[1.5] text-ink-900 md:text-3xl" data-id="element-3734" data-mp="3o22mgu1y8wmu">
              التبرعات
            </h2>
            <p data-id="element-3735" data-mp="3j26lz4sgnnc1">
              تُعد التبرعات المقدمة إلى المركز الدولي للتعلّم الإسلامي هبات نهائية.
              وهي طوعية وغير قابلة للاسترداد تحت أي ظرف.
            </p>
            <div data-id="element-3736" data-mp="27njj17e7al53">
              <h3 className="font-display text-2xl font-semibold leading-[1.5] text-ink-900 md:text-3xl" data-id="element-3737" data-mp="27n1fdpp7l4n5">
                إشعار بشأن سياسة الزكاة
              </h3>
              <p className="mt-3" data-id="element-3738" data-mp="owvywhq9y444">
                نقبل الصدقات والمنح المؤسسية؛ ويُرجى العلم بأن الزكاة لا تُقبل في هذه
                المرحلة. إذا أرسلت أموال زكاة عن طريق الخطأ، فيُرجى التواصل فورًا مع
                فريق الدعم عبر{' '}
                <a href="mailto:support@iilh.org" className="font-medium text-forest-700 underline underline-offset-2 transition hover:text-forest-800" dir="ltr" data-id="element-3739" data-mp="fuwctb0ek9ub">
                  support@iilh.org
                </a>{' '}
                لترتيب إعادة مساهمتك على وجه السرعة.
              </p>
            </div>

            <h2 className="mt-12 font-display text-2xl font-semibold leading-[1.5] text-ink-900 md:text-3xl" data-id="element-3740" data-mp="3tcf5x9xlu71k">
              العضويات
            </h2>
            <p data-id="element-3741" data-mp="3egfsdjrq7ep1">
              <strong data-id="element-3742" data-mp="3jcwob0562xco">الفترات السارية:</strong> لا تُسترد رسوم العضوية بمجرد بدء فترة
              العضوية، سواء كانت شهرية أو سنوية.
            </p>
            <p data-id="element-3743" data-mp="30a4a1ikkxe5v">
              <strong data-id="element-3744" data-mp="30antx4tsicmj">الإلغاء:</strong> يمكنك إلغاء عضويتك في أي وقت لمنع إصدار فواتير
              للفترات المستقبلية.
            </p>

            <h2 className="mt-12 font-display text-2xl font-semibold leading-[1.5] text-ink-900 md:text-3xl" data-id="element-3745" data-mp="2qii1jtzmlt6t">
              البرامج المدفوعة
            </h2>
            <p data-id="element-3746" data-mp="2llhupguycmen">
              <strong data-id="element-3747" data-mp="2lhu3ioczcc33">الشروط الخاصة بالبرنامج:</strong> تختلف أهلية الاسترداد باختلاف
              الدورة. وتوضّح الشروط الخاصة في صفحة التسجيل لكل برنامج.
            </p>
            <p data-id="element-3748" data-mp="3e8vpp9f3b7w4">
              <strong data-id="element-3749" data-mp="3e69dgwh9847k">الاسترداد الجزئي:</strong> وفقًا لتقدير المنظمة وحدها، قد يُتاح
              استرداد جزئي إذا قُدِّم الطلب قبل بدء البرنامج.
            </p>

            <h2 className="mt-12 font-display text-2xl font-semibold leading-[1.5] text-ink-900 md:text-3xl" data-id="element-3750" data-mp="349d4kpng1g2h">
              الظروف الاستثنائية
            </h2>
            <p data-id="element-3751" data-mp="1sv9brmsldxz0">
              ندرك أن الحياة قد تكون غير متوقعة. ويمكن مراجعة طلبات الاسترداد المقدمة
              بسبب ظروف استثنائية، مثل الحالات الطبية الطارئة، كلٌّ على حدة.
            </p>
          </div>
        </article>
      </Container>
    </section>;
}